module.exports = __webpack_public_path__ + "img/plant01.81a6b204.jpg";